import React from "react";
import { severityStyle } from "./anomalyTheme";

const badgeBase = {
  display: "inline-block",
  padding: "4px 10px",
  borderRadius: "6px",
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.4px",
  lineHeight: 1.3,
  textTransform: "uppercase",
};

const SeverityBadge = ({ severity, children }) => {
  const style = severityStyle(severity);
  return (
    <span
      style={{
        ...badgeBase,
        background: style.background,
        color: style.color,
      }}
    >
      {children ?? severity ?? "—"}
    </span>
  );
};

export default SeverityBadge;
